import {
  CampaignWithCampaignComponentFragment,
  CampaignWithCampaignComponentsFragment,
  Publication_Status_Type,
} from '@occc/graphql';

export type CampaignComponentSanitized = Pick<
  CampaignWithCampaignComponentFragment,
  'id' | 'name' | 'description' | 'category' | 'externalId' | 'deleted'
>;

export type CampaignWithCampaignComponentsSanitized = Pick<
  CampaignWithCampaignComponentsFragment,
  'uuid' | 'name' | 'category' | 'deleted' | 'description' | 'externalId'
> & {
  campaignComponents: CampaignComponentSanitized[] | null;
};

export enum CampaignStatusFilter {
  All = 'All',
  Active = 'Active',
  Archived = 'Archived',
}

export type CampaignsFilterFormValues = {
  status: CampaignStatusFilter;
  publicationStatus: Publication_Status_Type;
};
